import React from 'react';
import { connect } from 'react-redux';
import RegionIcon from '@material-ui/icons/Public';
import WhistleIcon from '../../../assets/icons/WhistleIcon';
import { getReducedEntityObjectList } from '../../../redux/reducers';
import constants from '../../../utils/constants';
import RefereeEntityListItem from './RefereeEntityListItem';
import EntitySearch from '../components/EntitiySearch';

const RefereeSearch = connect(state => ({
  entities: getReducedEntityObjectList(state.entities.referees),
}))(props => (
  <EntitySearch
    {...{
      ...props,
      title: 'Referees',
      entityType: constants.entityType.referee,
      EntityListItem: RefereeEntityListItem,
      searches: [
        {
          search: 'name',
          leftIcon: <WhistleIcon />,
          hintText: 'Referee',
        },
        {
          search: 'region',
          leftIcon: <RegionIcon />,
          hintText: 'Region',
        },
      ],
    }}
  />
));

export default RefereeSearch;
